

  /* ── NAV scroll behaviour ─────────────── */
  const header = document.getElementById('siteHeader');
  // var pincodes = document.querySelector('html').getAttribute('pincodes');
  if(header){
    const navLogoImg = header.querySelector('.nav-logo-img'), nav_white_logo = header.querySelector('.nav-logo-img.white'),
          nav_black_logo = header.querySelector('.nav-logo-img.black');
    const themedBlocks = Array.from(document.querySelectorAll('section, footer'));

    // Which section sits directly under the header right now? Return its theme.
    function currentSectionTheme() {
    const probe = header.offsetHeight + 1;   // a point just below the header
    for (const el of themedBlocks) {
        const r = el.getBoundingClientRect();
        if (r.top <= probe && r.bottom > probe) {
        return el.dataset.header === 'dark' ? 'dark' : 'light';
        }
    }
    return 'light';
    }

    function updateHeader() {
      const scrolled = window.scrollY > 30;
      header.classList.toggle('scrolled', scrolled);
      const onDark = scrolled && currentSectionTheme() === 'dark';
      header.classList.toggle('on-dark', onDark);
      // White logo when transparent (over hero) or over a dark section; black on light sections
      if (navLogoImg) 
        header.classList.contains('on-dark') ? (nav_white_logo.classList.remove('hidden'),nav_black_logo.classList.add('hidden')) : (nav_white_logo.classList.add('hidden'),nav_black_logo.classList.remove('hidden'));
    }
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
    window.addEventListener('resize', updateHeader);
  }

  /* ── Hero Image Slider ───────────────── */
  (function() {
    const slides = document.querySelectorAll('.hero-slide');
    const dotsWrap = document.getElementById('heroDots');
    let cur = 0;
    const dots = [];

    if(slides.length > 0){
      slides.forEach((_, i) => {
        const d = document.createElement('button');
        d.className = 'hero-dot' + (i === 0 ? ' active' : '');
        d.setAttribute('aria-label', 'Slide ' + (i+1));
        d.onclick = () => goTo(i);
        dotsWrap.appendChild(d);
        dots.push(d);
      });

      function goTo(n) {
        slides[cur].classList.remove('active');
        dots[cur].classList.remove('active');
        cur = n;
        slides[cur].classList.add('active');
        dots[cur].classList.add('active');
      }

      /* start first slide */
      slides[0].classList.add('active');

      /* auto-advance every 5 s */
      setInterval(() => goTo((cur + 1) % slides.length), 5000);
    }
  })();

  /* ── Mobile menu ── */
  const hamburger = document.getElementById('hamburger');
  if(hamburger){
    const hamburger = document.getElementById('hamburger');
    const mobileMenu = document.getElementById('mobileMenu');
    hamburger.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
      hamburger.classList.toggle('open');
      document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
    });
    function closeMobileMenu() {
      mobileMenu.classList.remove('open');
      hamburger.classList.remove('open');
      document.body.style.overflow = '';
    }

    /* ── Scroll reveal ────────────────────── */
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(e => {
        if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            observer.unobserve(e.target);
        }
        });
    }, { threshold: 0.12 });
  
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
  }
  /* ── Process timeline animation (sequential fill on scroll) ── */
  const stepsGrid = document.querySelector('.steps-grid');
  if (stepsGrid) {
    const stepsObserver = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in-view');
          stepsObserver.unobserve(e.target);
        }
      });
    }, { threshold: 0.4 });
    stepsObserver.observe(stepsGrid);
  }

  /* ── Pincode popup ──────────────────── */
  function togglePincodePopup() {
    const popup    = document.getElementById('pinPopup');
    const backdrop = document.getElementById('pinPopupBackdrop');
    const isOpen   = popup.classList.contains('open');
    if (isOpen) {
      closePincodePopup();
    } else {
      popup.classList.add('open');
      backdrop.classList.add('open');
      setTimeout(() => document.getElementById('navPincodeInput').focus(), 250);
    }
  }

  function closePincodePopup() {
    document.getElementById('pinPopup').classList.remove('open');
    document.getElementById('pinPopupBackdrop').classList.remove('open');
  }

  /* ── Footer newsletter subscribe ─────── */
  function footerSubscribe() {
    const inp = document.getElementById('footerEmail');
    const val = inp.value.trim();
    if (!val || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
      inp.style.outline = '1px solid #C05A4A';
      setTimeout(() => inp.style.outline = '', 1500);
      return;
    }
    const btn = inp.nextElementSibling;
    btn.textContent = '✓ Done!';
    btn.style.background = '#7A8C78';
    inp.value = '';
    inp.disabled = true;
    inp.placeholder = 'You\'re subscribed!';
    setTimeout(() => {
      btn.textContent = 'Subscribe'; btn.style.background = '';
      inp.disabled = false; inp.placeholder = 'your@email.com';
    }, 4000);
  }

  /* Close on Escape */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closePincodePopup();
  });

  function checkNavPincode() {
    const input  = document.getElementById('navPincodeInput').value.trim();
    const result = document.getElementById('navPincodeResult');
    result.className = '';

    if (input.length !== 6 || !/^\d{6}$/.test(input)) {
      result.textContent = '⚠ Please enter a valid 6-digit pincode';
      result.className = 'unavailable';
      return;
    }
    if (availablePincodes.has(input)) {
      // result.innerHTML = '✓ &nbsp;We deliver to <strong>' + input + '</strong>! Order before 8 PM for next-day delivery.';
      result.innerHTML = "✓ We're delighted to serve your area. Order before 11 AM for same day delivery.";
      result.className = 'available';
      pincodeVerified = true;
      document.cookie = `pincode_set=${input}`
      window.location.reload();
    } else {
      result.textContent = '✗ Not yet — we\'re expanding soon. Stay tuned!';
      result.className = 'unavailable';
      // window.location.assign();
    }
  }

  let pincodeVerified = false;
  // if(pincodes){
    const availablePincodes = new Set(pincodes);
  // }

  console.log(availablePincodes)

  // let pincodeVerified = false;
  // const availablePincodes = new Set([
    
  //   // Delhi NCR
  //   '110001','110003','110017','110021','110024','110025','110048','110057','110062',
  //   '110070','110074','110016','110030','110011','110022','110066','110023','110067',
  //   '110019','110020','110014','110013','110075','110077','110078','110029','110049','110065',
  //   // Gurugram
  //   '122001','122002','122003','122008','122009','122010','122011','122018','122022','122101','122017','122015','122007','122098'
    
  // ]);

  var cookies = document.cookie, cookies_split = cookies.split(';');
  cookies_split.forEach(function(cookie){
    var cookie_left = cookie.split('=')[0], cookie_right = cookie.split('=')[1];
    if(cookie_left == 'pincode_set'){
      pincodeVerified = true;
    }
  })


  /* ── FAQ accordion ───────────────────── */
  function toggleFaq(btn) {
    const item = btn.closest('.faq-item');
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
    if (!isOpen) item.classList.add('open');
  }

  /* ── Reviews carousel ────────────────── */
  let currentSlide = 0;
  const carousel = document.getElementById('reviewsCarousel');
  if(carousel){
    const dots = document.querySelectorAll('.carousel-dot');
    const cards = carousel.querySelectorAll('.review-card');
    const cardsPerView = () => window.innerWidth < 768 ? 1 : 3;
    const maxSlide = () => cards.length - cardsPerView();

    function updateCarousel() {
      const cardW = cards[0].offsetWidth + 24; // gap
      carousel.style.transform = `translateX(-${currentSlide * cardW}px)`;
      carousel.style.transition = 'transform 0.5s cubic-bezier(0.25,0.46,0.45,0.94)';
      dots.forEach((d, i) => d.classList.toggle('active', i === Math.min(currentSlide, dots.length - 1)));
    }

    function slideReviews(dir) {
      currentSlide = Math.max(0, Math.min(currentSlide + dir, maxSlide()));
      updateCarousel();
    }

    function goToSlide(i) {
      currentSlide = Math.min(i, maxSlide());
      updateCarousel();
    }

    carousel.style.display = 'flex';
    carousel.style.overflow = 'visible';

    /* Auto-play */
    setInterval(() => slideReviews(1), 4500);

    window.addEventListener('resize', () => {
      currentSlide = Math.min(currentSlide, maxSlide());
      updateCarousel();
    });
  }

  /* ═══════════════════════════════════════════════════
     LEAD CAPTURE POPUP
     – Shows after 4s on first visit only
     – Skipped/submitted → stored in localStorage
  ═══════════════════════════════════════════════════ */
  // (function () {
  //   const STORAGE_KEY = 'nouriq_popup_done';

  //   const backdrop     = document.getElementById('popupBackdrop');
  //   const closeBtn     = document.getElementById('popupClose');
  //   const skipBtn      = document.getElementById('popupSkip');
  //   const form         = document.getElementById('popupForm');
  //   const phoneInput   = document.getElementById('popupPhone');
  //   const inputGroup   = document.getElementById('popupInputGroup');
  //   const errorMsg     = document.getElementById('popupError');
  //   const formView     = document.getElementById('popupFormView');
  //   const successView  = document.getElementById('popupSuccessView');

  //   /* Open popup */
  //   function openPopup() {
  //     backdrop.classList.add('open');
  //     // Trap focus inside card
  //     setTimeout(() => phoneInput.focus(), 500);
  //   }

  //   /* Close popup + mark as seen */
  //   window.closePopup = function () {
  //     backdrop.classList.remove('open');
  //   };

  //   /* Show after 4 seconds (middle of 3–5s range) */
  //   const timer = setTimeout(openPopup, 4000);

  //   /* Close via X button */
  //   closeBtn.addEventListener('click', closePopup);

  //   /* Close via Skip */
  //   skipBtn.addEventListener('click', closePopup);

  //   /* Close via backdrop click (outside card) */
  //   backdrop.addEventListener('click', function (e) {
  //     if (e.target === backdrop) closePopup();
  //   });

  //   /* Close via Escape key */
  //   document.addEventListener('keydown', function (e) {
  //     if (e.key === 'Escape' && backdrop.classList.contains('open')) closePopup();
  //   });

  //   /* Phone number — only allow digits */
  //   phoneInput.addEventListener('input', function () {
  //     this.value = this.value.replace(/\D/g, '').slice(0, 10);
  //     inputGroup.classList.remove('error');
  //     errorMsg.classList.remove('show');
  //   });

  //   /* Form submit */
  //   form.addEventListener('submit', function (e) {
  //     e.preventDefault();
  //     const phone = phoneInput.value.trim();

  //     /* Validate: 10 digits, starts with 6–9 */
  //     if (!/^[6-9]\d{9}$/.test(phone)) {
  //       inputGroup.classList.add('error');
  //       errorMsg.classList.add('show');
  //       phoneInput.focus();
  //       return;
  //     }

  //     /* Success — show success state (class-based, not [hidden], to avoid display override) */
  //     formView.style.display = 'none';
  //     successView.classList.add('show');

  //     /* In production: POST to your backend / WhatsApp API here */
  //     // fetch('/api/lead', { method:'POST', body: JSON.stringify({ phone }) });
  //   });

  //   /* Cancel timer if user interacts with page quickly */
  //   ['scroll', 'click', 'keydown'].forEach(evt => {
  //     window.addEventListener(evt, function interactHandler() {
  //       // Don't cancel — still show at 4s even if user is active
  //       // (Remove this listener to avoid leaks)
  //       window.removeEventListener(evt, interactHandler);
  //     }, { once: true });
  //   });

  // })();

